import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId,
  measurementId: process.env.VUE_APP_measurementId
};
// Init Firebase Instance
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED // Setting Maximum Cache
});

// Enable Firebase Persistence
firebase.firestore().enablePersistence();

// Firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const storage = firebase.storage();
const fb = firebase;
const usersCollection = db.collection("users");
const equipmentsCollection = db.collection("equipments");
const inspectionsCollection = db.collection("inspections");
const repairsCollection = db.collection("repairs");
const sparePartsCollection = db.collection("spareParts");
const reliabilitiesCollection = db.collection("reliabilities");
const functions = firebase.functions();

export {
  functions,
  reliabilitiesCollection,
  inspectionsCollection,
  usersCollection,
  equipmentsCollection,
  repairsCollection,
  sparePartsCollection,
  fb,
  auth,
  db,
  storage,
  timestamp
};
